(function () {
  'use strict';

  var enabled = window.theme && window.theme.settings && window.theme.settings.enable_related_by_custom_id;
  if (!enabled) return;

  var siblingCacheByCustomId = {};
  var handleCustomIdCache = {};
  var fillPromises = {};

  function getThumbImage(productData) {
    if (productData.image) return productData.image;
    if (productData.images && productData.images.length) return productData.images[0];
    return '';
  }

  function normalizeTitle(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function cleanProductUrl(url) {
    if (!url) return '';
    return url.split('?')[0];
  }

  function dedupeByHandle(items) {
    var seen = {};
    return items.filter(function (item) {
      if (!item.handle || seen[item.handle]) return false;
      seen[item.handle] = true;
      return Boolean(item.url || item.image || (item.images && item.images.length));
    });
  }

  function fetchCustomIdForHandle(handle) {
    if (Object.prototype.hasOwnProperty.call(handleCustomIdCache, handle)) {
      return Promise.resolve(handleCustomIdCache[handle]);
    }

    var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=lop-custom-id', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('custom-id view failed');
        return response.text();
      })
      .then(function (text) {
        var data = JSON.parse(text);
        var customId = String(data.customId || '');
        handleCustomIdCache[handle] = customId;
        return customId;
      })
      .catch(function () {
        handleCustomIdCache[handle] = '';
        return '';
      });
  }

  function filterItemsByCustomId(items, expectedCustomId) {
    if (!items.length || !expectedCustomId) return Promise.resolve([]);

    return Promise.all(
      items.map(function (item) {
        return fetchCustomIdForHandle(item.handle).then(function (id) {
          return id === expectedCustomId ? item : null;
        });
      })
    ).then(function (results) {
      return results.filter(Boolean);
    });
  }

  function requestSuggestJson(searchTitle) {
    var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    var url =
      root +
      'search/suggest.json?q=' +
      encodeURIComponent(searchTitle) +
      '&resources[type]=product&resources[limit]=10';

    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('suggest failed');
      return response.json();
    });
  }

  function prefetchSuggestForTitle(searchTitle) {
    if (!searchTitle) return;

    window.__lopRelatedPrefetchByTitle = window.__lopRelatedPrefetchByTitle || {};
    var key = normalizeTitle(searchTitle);

    if (!window.__lopRelatedPrefetchByTitle[key]) {
      window.__lopRelatedPrefetchByTitle[key] = requestSuggestJson(searchTitle).catch(function () {
        return null;
      });
    }
  }

  function fetchSuggestProducts(searchTitle) {
    var key = normalizeTitle(searchTitle);
    var cached = window.__lopRelatedPrefetchByTitle && window.__lopRelatedPrefetchByTitle[key];

    if (cached) {
      return cached.then(function (data) {
        return data || requestSuggestJson(searchTitle);
      });
    }

    if (window.__lopRelatedPrefetch && window.__lopRelatedPrefetchTitle === searchTitle) {
      return window.__lopRelatedPrefetch.then(function (data) {
        return data || requestSuggestJson(searchTitle);
      });
    }

    return requestSuggestJson(searchTitle);
  }

  function parseSuggestProducts(data, searchTitle) {
    var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    var targetTitle = normalizeTitle(searchTitle);

    return products
      .filter(function (product) {
        return normalizeTitle(product.title) === targetTitle;
      })
      .map(function (product) {
        var image = product.image || (product.featured_image && product.featured_image.url) || '';
        return {
          handle: product.handle,
          url: cleanProductUrl(product.url),
          title: product.title,
          image: image,
          images: image ? [image] : [],
        };
      });
  }

  function readThumbItems(swatchContainer) {
    var items = [];

    swatchContainer.querySelectorAll('.product-card-related-thumb').forEach(function (thumb) {
      var handle = thumb.getAttribute('data-product-handle') || '';
      var images =
        typeof ProductCard !== 'undefined' && ProductCard.parseProductImages
          ? ProductCard.parseProductImages(thumb.getAttribute('data-product-images'))
          : (thumb.getAttribute('data-product-images') || '').split('||').filter(Boolean);
      var img = thumb.querySelector('img');

      items.push({
        handle: handle,
        url: thumb.getAttribute('href') || thumb.href || '',
        title: thumb.getAttribute('title') || '',
        image: img ? img.getAttribute('src') : '',
        images: images,
      });
    });

    return dedupeByHandle(items);
  }

  function getGroupContainers() {
    var selectors = [
      '.LOP-search-results-products',
      '#LOP-search-results-grid',
      '.LOP-search-overlay__results-grid',
      '#ProductGridContainer',
      '.product-collection',
      '.collection .product-grid',
      'main-search .product-grid'
    ];
    var seen = [];
    var containers = [];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (seen.indexOf(el) === -1) {
          seen.push(el);
          containers.push(el);
        }
      });
    });

    return containers;
  }

  function buildProductData(card) {
    var images =
      typeof ProductCard !== 'undefined' && ProductCard.parseProductImages
        ? ProductCard.parseProductImages(card.getAttribute('data-product-images'))
        : (card.getAttribute('data-product-images') || '').split('||').filter(Boolean);

    return {
      handle: card.getAttribute('data-product-handle'),
      image: card.getAttribute('data-product-image'),
      images: images,
      url: card.getAttribute('data-product-url'),
      title: card.getAttribute('data-product-title'),
      card: card,
    };
  }

  function addUniqueToGroup(groupMap, customId, productData) {
    if (!customId || !productData.handle) return;
    if (!groupMap[customId]) {
      groupMap[customId] = [];
    }
    var exists = groupMap[customId].some(function (item) {
      return item.handle === productData.handle;
    });
    if (!exists) {
      groupMap[customId].push(productData);
    }
  }

  function buildThumbHtml(sibling, isActive) {
    var siblingImage = getThumbImage(sibling);
    if (!siblingImage) return '';

    return (
      '<a href="' +
      sibling.url +
      '" class="product-card-related-thumb' +
      (isActive ? ' product-card-related-thumb--active' : '') +
      '" data-product-handle="' +
      sibling.handle +
      '" data-product-images="' +
      (sibling.images || []).join('||') +
      '" title="' +
      sibling.title +
      '">' +
      '<img src="' +
      siblingImage +
      '" alt="' +
      sibling.title +
      '" loading="lazy" width="36" height="36">' +
      '</a>'
    );
  }

  function preloadThumbImages(items) {
    items.forEach(function (item) {
      var src = getThumbImage(item);
      if (!src) return;
      var img = new Image();
      img.src = src;
    });
  }

  function updateOverflowIndicators(swatchContainer, totalItems) {
    swatchContainer.querySelectorAll('.product-card-related-more').forEach(function (el) {
      el.remove();
    });
    swatchContainer.classList.remove('has-overflow-desktop', 'has-overflow-mobile');

    if (totalItems > 5) {
      swatchContainer.insertAdjacentHTML(
        'beforeend',
        '<span class="product-card-related-more product-card-related-more--desktop">+' +
          (totalItems - 5) +
          '</span>'
      );
      swatchContainer.classList.add('has-overflow-desktop');
    }

    if (totalItems > 3) {
      swatchContainer.insertAdjacentHTML(
        'beforeend',
        '<span class="product-card-related-more product-card-related-more--mobile">+' +
          (totalItems - 3) +
          '</span>'
      );
      swatchContainer.classList.add('has-overflow-mobile');
    }
  }

  function registerThumbInteractions(swatchContainer, items) {
    swatchContainer.setAttribute('data-thumbs-bound', 'true');

    swatchContainer.querySelectorAll('.product-card-related-thumb').forEach(function (thumb) {
      if (typeof ProductCard !== 'undefined' && ProductCard.registerThumbImages) {
        ProductCard.registerThumbImages(thumb);
      }
    });

    (items || []).forEach(function (item) {
      if (!item.handle || !item.images || !item.images.length) return;
      if (typeof ProductCard !== 'undefined') {
        if (!ProductCard._imageCache) {
          ProductCard._imageCache = {};
        }
        ProductCard._imageCache[item.handle] = item.images;
      }
    });
  }

  function appendMissingSwatches(swatchContainer, newItems, allItems) {
    if (!swatchContainer || !newItems.length) return;

    preloadThumbImages(newItems);

    var existingHandles = {};
    readThumbItems(swatchContainer).forEach(function (item) {
      existingHandles[item.handle] = true;
    });

    newItems.forEach(function (sibling) {
      if (existingHandles[sibling.handle]) return;

      var html = buildThumbHtml(sibling, false);
      if (!html) return;

      existingHandles[sibling.handle] = true;
      swatchContainer.insertAdjacentHTML('beforeend', html);
    });

    var totalItems = swatchContainer.querySelectorAll('.product-card-related-thumb').length;
    updateOverflowIndicators(swatchContainer, totalItems);
    registerThumbInteractions(swatchContainer, allItems || newItems);
  }

  function applySwatchFill(swatchContainer, merged, current, currentItems) {
    var newItems = merged.filter(function (item) {
      return !currentItems.some(function (existing) {
        return existing.handle === item.handle;
      });
    });

    if (currentItems.length >= 2 && newItems.length > 0) {
      appendMissingSwatches(swatchContainer, newItems, merged);
      return;
    }

    renderSwatchesOnCard(swatchContainer, merged, current);
  }

  function renderSwatchesOnCard(swatchContainer, group, activeProduct) {
    if (!swatchContainer || !group.length || !activeProduct) return;

    var totalItems = group.length;
    var html = buildThumbHtml(activeProduct, true);
    var renderedHandles = {};
    renderedHandles[activeProduct.handle] = true;

    group.forEach(function (sibling) {
      if (renderedHandles[sibling.handle]) return;
      var thumbHtml = buildThumbHtml(sibling, false);
      if (!thumbHtml) return;
      renderedHandles[sibling.handle] = true;
      html += thumbHtml;
    });

    swatchContainer.innerHTML = html;
    updateOverflowIndicators(swatchContainer, totalItems);
    registerThumbInteractions(swatchContainer, group);
  }

  function fillSingleCardGroupAsync(current, customId) {
    var card = current.card;
    var swatchContainer = card.querySelector('.product-card-related-products');
    var searchTitle = card.getAttribute('data-product-title');
    var fillKey = customId + ':' + current.handle;

    if (fillPromises[fillKey]) {
      return fillPromises[fillKey];
    }

    var promise = new Promise(function (resolve) {
      if (!swatchContainer || !searchTitle) {
        resolve({ status: 'skip', reason: 'missing-container' });
        return;
      }
      if (swatchContainer.getAttribute('data-suggest-filled') === 'true') {
        resolve({ status: 'skip', reason: 'already-filled' });
        return;
      }

      var currentItems = readThumbItems(swatchContainer);
      var cached = siblingCacheByCustomId[customId];

      if (cached && cached.length > currentItems.length) {
        applySwatchFill(swatchContainer, cached, current, currentItems);
        swatchContainer.setAttribute('data-suggest-filled', 'true');
        resolve({ status: 'filled', source: 'cache', mergedCount: cached.length });
        return;
      }

      prefetchSuggestForTitle(searchTitle);

      fetchSuggestProducts(searchTitle)
        .then(function (data) {
          var searchItems = parseSuggestProducts(data, searchTitle);
          var knownHandles = {};

          currentItems.forEach(function (item) {
            knownHandles[item.handle] = true;
          });

          var candidates = searchItems.filter(function (item) {
            return !knownHandles[item.handle];
          });

          return filterItemsByCustomId(candidates, customId).then(function (validatedNew) {
            return dedupeByHandle(currentItems.concat(validatedNew));
          });
        })
        .then(function (merged) {
          if (!merged.length || merged.length <= currentItems.length) {
            if (merged.length >= 2) {
              siblingCacheByCustomId[customId] = merged;
            }
            swatchContainer.setAttribute('data-suggest-filled', 'true');
            resolve({
              status: 'noop',
              mergedCount: merged ? merged.length : 0,
            });
            return;
          }

          siblingCacheByCustomId[customId] = merged;
          preloadThumbImages(
            merged.filter(function (item) {
              return !currentItems.some(function (existing) {
                return existing.handle === item.handle;
              });
            })
          );
          applySwatchFill(swatchContainer, merged, current, currentItems);
          swatchContainer.setAttribute('data-suggest-filled', 'true');
          resolve({
            status: 'filled',
            source: 'suggest',
            mergedCount: merged.length,
          });
        })
        .catch(function () {
          resolve({ status: 'error' });
        });
    });

    fillPromises[fillKey] = promise;
    promise.finally(function () {
      delete fillPromises[fillKey];
    });
    return promise;
  }

  function fillSingleCardGroup(current, customId) {
    fillSingleCardGroupAsync(current, customId);
  }

  function prepareSearchOverlaySwatches(containerEl) {
    var cards = containerEl.querySelectorAll('product-card[data-custom-id]');
    if (!cards.length) {
      return Promise.resolve({ prepared: 0 });
    }

    var titlesSeen = {};
    cards.forEach(function (card) {
      var title = card.getAttribute('data-product-title');
      if (title && !titlesSeen[title]) {
        titlesSeen[title] = true;
        prefetchSuggestForTitle(title);
      }
    });

    var idMap = {};
    cards.forEach(function (card) {
      addUniqueToGroup(idMap, card.getAttribute('data-custom-id'), buildProductData(card));
    });

    var promises = [];
    Object.keys(idMap).forEach(function (customId) {
      var group = idMap[customId];
      if (group.length < 2) {
        group.forEach(function (current) {
          promises.push(fillSingleCardGroupAsync(current, customId));
        });
      }
    });

    if (!promises.length) {
      return Promise.resolve({ prepared: 0, reason: 'multi-card-group' });
    }

    return Promise.all(promises);
  }

  window.LOPSearchSwatchPrepare = prepareSearchOverlaySwatches;

  function processContainer(containerEl) {
    var cards = containerEl.querySelectorAll('product-card[data-custom-id]');
    if (!cards.length) return;

    var titlesSeen = {};
    cards.forEach(function (card) {
      var title = card.getAttribute('data-product-title');
      if (title && !titlesSeen[title]) {
        titlesSeen[title] = true;
        prefetchSuggestForTitle(title);
      }
    });

    var idMap = {};

    cards.forEach(function (card) {
      addUniqueToGroup(idMap, card.getAttribute('data-custom-id'), buildProductData(card));
    });

    Object.keys(idMap).forEach(function (customId) {
      var group = idMap[customId];
      if (group.length < 2) {
        group.forEach(function (current) {
          fillSingleCardGroup(current, customId);
        });
        return;
      }

      group.forEach(function (current) {
        var swatchContainer = current.card.querySelector('.product-card-related-products');
        if (!swatchContainer) return;

        var liquidCount = readThumbItems(swatchContainer).length;

        if (liquidCount > group.length) {
          fillSingleCardGroup(current, customId);
          return;
        }

        if (group.length > liquidCount) {
          renderSwatchesOnCard(swatchContainer, group, current);
          return;
        }

        fillSingleCardGroup(current, customId);
      });
    });

    Object.keys(idMap).forEach(function (customId) {
      idMap[customId].forEach(function (item) {
        if (!item.handle || !item.images || !item.images.length) return;
        if (typeof ProductCard !== 'undefined') {
          if (!ProductCard._imageCache) {
            ProductCard._imageCache = {};
          }
          ProductCard._imageCache[item.handle] = item.images;
        }
      });
    });
  }

  function init() {
    var containers = getGroupContainers();

    if (!containers.length) {
      processContainer(document.body);
    } else {
      containers.forEach(processContainer);
    }

    if (typeof ProductCard !== 'undefined' && ProductCard.warmImageCache) {
      ProductCard.warmImageCache();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('LOP:search:results', init);

  var observer = new MutationObserver(function (mutations) {
    var hasNewCards = false;
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function (node) {
          if (
            node.nodeType === 1 &&
            (node.tagName === 'PRODUCT-CARD' || node.querySelector('product-card[data-custom-id]'))
          ) {
            hasNewCards = true;
          }
        });
      }
    });
    if (hasNewCards) {
      init();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
